import React, { useState } from 'react';
import { Container, Typography, Box, Card, Grid, Avatar, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { motion } from 'framer-motion';
import ariesImage from '../images/aries.png';
import taurusImage from '../images/taurus.png';
import geminiImage from '../images/gemini.png';
import cancerImage from '../images/cancer.png';
import leoImage from '../images/leo.png';
import virgoImage from '../images/virgo.png';
import libraImage from '../images/libra.png';
import scorpioImage from '../images/scorpio.png';
import sagittariusImage from '../images/sagitarius.png';
import capricornImage from '../images/capricon.png';
import aquariusImage from '../images/aquarius.png';
import piscesImage from '../images/pisces.png';

// Data zodiak
const zodiacSigns = [
    {
        name: "Aries",
        dateRange: "March 21 - April 19",
        element: "Fire",
        characteristics: [
            "Courageous",
            "Determined",
            "Confident",
            "Enthusiastic",
            "Optimistic",
            "Honest",
            "Passionate"
        ],
        events: [
            { name: "Spring Equinox", date: "March 21", description: "Marks the beginning of Aries season." },
            { name: "Aries New Moon", date: "Varies", description: "A powerful time for setting intentions and new beginnings." }
        ],
        image: ariesImage
    },
    {
        name: "Taurus",
        dateRange: "April 20 - May 20",
        element: "Earth",
        characteristics: [
            "Reliable",
            "Patient",
            "Practical",
            "Devoted",
            "Responsible",
            "Stable"
        ],
        events: [
            { name: "Beltane", date: "May 1", description: "A festival celebrating fertility, marking Taurus season." },
            { name: "Taurus Full Moon", date: "Varies", description: "A time for harvest and celebration of abundance." }
        ],
        image: taurusImage
    },
    // Tambahkan zodiak lainnya di sini dengan format yang sama
];

// Komponen utama
const ZodiacEventsAndFestivals = () => {
    const [selectedZodiac, setSelectedZodiac] = useState('');

    const handleZodiacChange = (event) => {
        setSelectedZodiac(event.target.value);
    };

    const zodiacInfo = zodiacSigns.find(z => z.name === selectedZodiac);

    return (
        <Container>
            <Typography variant="h4" align="center" gutterBottom>Zodiac Events and Festivals</Typography>

            <FormControl fullWidth margin="normal">
                <InputLabel>Select Your Zodiac Sign</InputLabel>
                <Select
                    value={selectedZodiac}
                    onChange={handleZodiacChange}
                >
                    {zodiacSigns.map((zodiac) => (
                        <MenuItem key={zodiac.name} value={zodiac.name}>
                            {zodiac.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {zodiacInfo && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    <Card sx={{ padding: 2, marginTop: 3 }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={4}>
                                <Avatar 
                                    src={zodiacInfo.image} 
                                    alt={zodiacInfo.name} 
                                    sx={{ width: 120, height: 120, margin: 'auto' }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <Typography variant="h5">{zodiacInfo.name} ({zodiacInfo.dateRange})</Typography>
                                <Typography variant="body1">Element: {zodiacInfo.element}</Typography>
                                <Typography variant="body2" gutterBottom>
                                    Characteristics: {zodiacInfo.characteristics.join(', ')}
                                </Typography>
                                <Box mt={2}>
                                    <Typography variant="h6">Events & Festivals:</Typography>
                                    {zodiacInfo.events.map((event, index) => (
                                        <Typography key={index} variant="body2">
                                            {event.name} ({event.date}): {event.description}
                                        </Typography>
                                    ))}
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                </motion.div>
            )}
        </Container>
    );
};

export default ZodiacEventsAndFestivals;
